module.exports={render:function (){with(this) {
  return _h('div', [_h('div', {
    staticClass: "container-fluid bg-primary frontBanner"
  }, [_h('div', {
    staticClass: "container"
  }, [_h('div', {
    staticClass: "row"
  }, [_m(0), " ", _h('div', {
    staticClass: "col-lg-8"
  }, [_m(1), " ", _m(2), " ", (this.authData) ? _h('div') : _h('div', {
    staticClass: "input-group input-group-lg"
  }, [_h('input', {
    directives: [{
      name: "model",
      value: (txtEmail),
      expression: "txtEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Your email address"
    },
    domProps: {
      "value": _s(txtEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) return;
        txtEmail = $event.target.value
      }
    }
  }), " ", _h('span', {
    staticClass: "input-group-btn"
  }, [_h('button', {
    staticClass: "btn btn-default btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": subscribeForInfo
    }
  }, ["Please email me further information"])])]), " ", " ", (messageError) ? _h('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_s(messageError)]) : _e(), " ", (messageSuccess) ? _h('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_s(messageSuccess)]) : _e()]), " ", _m(3)])])]), " ", _m(4)])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "col-lg-2"
  })
}},function (){with(this) {
  return _h('h1', {
    staticClass: "text-uppercase"
  }, ["AIDS Impact", _h('br'), "13th International Conference"])
}},function (){with(this) {
  return _h('h2', ["November 13th - 15th 2017, Cape Town"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "col-lg-2"
  })
}},function (){with(this) {
  return _h('div', {
    staticClass: "container aboutAIDSImpact text-center"
  }, [_h('div', {
    staticClass: "row"
  }, [_h('div', {
    staticClass: "col-lg-2"
  }), " ", _h('div', {
    staticClass: "col-lg-8"
  }, [_h('h2', {
    staticClass: "text-uppercase"
  }, ["ABOUT ", _h('strong', ["AIDSIMPACT"])]), " ", _h('hr'), " ", _h('p', {
    staticClass: "lead"
  }, ["\n          AIDSImpact is an international behavioral and psychosocial science conference that addresses issues related to HIV/AIDS prevention, treatment and care, focusing both globally and on specific communities and countries hardest hit by the HIV/AIDS epidemic.\n        "]), " ", _h('p', {
    staticClass: "lead"
  }, ["\n          AIDSImpact first convened in Amsterdam in 1991. Now, in 2017 the 13th AIDSImpact conference will be held in Cape Town.\n        "]), " ", _h('p', {
    staticClass: "lead"
  }, ["\n          Each AIDSImpact meeting attracts delegates new to the field as well as a core group of loyal psychosocial and behavioral researchers, prevention workers, community members and policy makers from universities and institutes across all five continents who use the biannual meeting to present their studies, interventions and prevention schemes. AIDSImpact has evolved as one of the leading platforms for understanding, updating and debating the behavioral, psychosocial and community facets of HIV in light of changing social conditions and medical advances. In fact, a review of past AIDSImpact scientific programs reveals the evolution of the psychosocial and behavioral response to the HIV epidemic over the past 25 years.\n        "]), " ", _h('p', {
    staticClass: "lead"
  }, ["\n          The 2017 Cape Town conference will promote pioneering work on understanding the dynamics of a changing epidemic. A key focus will be consideration of new choices for HIV - for prevention, treatment, care and strategic planning.\n        "])]), " ", _h('div', {
    staticClass: "col-lg-2"
  })])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutus.vue
 ** module id = 89
 ** module chunks = 2
 **/